import { useEffect, useState } from 'react'
import { Box, Divider, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import GreenTick from '../../svgs/greentick'
import RedCross from '../../svgs/redcross'
import FilledButton from '../FilledButton'
import { useStyles } from './styles'
const ValidateRow = (props) => {
  const {
    fieldkey,
    fieldvalue,
    confirmed,
    rejected,
    unenrolled,
    reviewedRowCount,
    setReviewedRowCount,
    approvedRowCount,
    setApprovedRowCount,
    currentSiteID,
  } = props
  const [selected, setSelected] = useState(false)
  const [validated, setValidated] = useState(false)
  useEffect(() => {
    setSelected(false)
    setValidated(false)
  }, [currentSiteID])
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Box className={classes.formfield}>
        <Box className={classes.fielddetails}>
          <Box style={{ color: '#939497', fontSize: '14px' }}>{fieldkey}</Box>
          <Box style={{ color: '#545455', fontSize: '16px' }}>{fieldvalue}</Box>
        </Box>
        {!selected && !confirmed && !rejected && !unenrolled ? (
          <Box className={classes.validatebuttons}>
            <FilledButton
              label="Approve"
              primary={true}
              width="140px"
              height="40px"
              onClick={() => {
                setSelected(true)
                setReviewedRowCount(reviewedRowCount + 1)
                setApprovedRowCount(approvedRowCount + 1)
                setValidated(true)
              }}
            ></FilledButton>
            <FilledButton
              label="Reject"
              primary={false}
              tertiary={true}
              width="140px"
              height="40px"
              onClick={() => {
                setSelected(true)
                setReviewedRowCount(reviewedRowCount + 1)
                setValidated(false)
              }}
            ></FilledButton>
          </Box>
        ) : (
          <Box className={classes.validatebuttons}>
            {validated || confirmed ? (
              <Box className={classes.selected}>
                <GreenTick></GreenTick>
                <Typography className={classes.selectedtext}>
                  Approved
                </Typography>
              </Box>
            ) : unenrolled || rejected ? null : (
              <Box className={classes.selected}>
                <RedCross></RedCross>
                <Typography className={classes.selectedtext}>
                  Rejected
                </Typography>
              </Box>
            )}
            {confirmed || rejected || unenrolled ? null : (
              <FilledButton
                label="Undo"
                primary={false}
                tertiary={true}
                width="140px"
                height="40px"
                onClick={() => {
                  setSelected(false)
                  if (validated) {
                    setApprovedRowCount(
                      approvedRowCount > 0 ? approvedRowCount - 1 : 0,
                    )
                    setValidated(false)
                  }
                  setReviewedRowCount(
                    reviewedRowCount > 0 ? reviewedRowCount - 1 : 0,
                  )
                }}
              ></FilledButton>
            )}
          </Box>
        )}
      </Box>
      <Divider></Divider>
    </div>
  )
}

const mapStateToProps = ({ applications }) => {
  const { currentSiteID } = applications
  return { currentSiteID }
}

export default connect(mapStateToProps, null)(ValidateRow)
